import { CustomSessionStorage } from '@/lib/storage/customSessionStorage';

const KEY = 'live-video-muted';

export const liveVideoStorage = CustomSessionStorage<boolean>(KEY);
